import React, { useEffect, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner'
import * as apiUtility from "../../config/APIUtils";
import { Tooltip } from "@mui/material";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from "react-icons/ri";
import { Box, Button, Sheet } from '@mui/joy';

function CourseExpiryReport(props) {
    const [expCrsData, setExpCrsData] = useState([]);
    const [showSpinner, setshowSpinner] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    useEffect(() => {
        fetchData();
    }, [props.homeId, props.expDate]);

    const fetchData = async () => {
            setshowSpinner(true);
            try {
                var requestBody = { ...props };

                requestBody.expDate.startDate = requestBody.expDate.startDate.split('T')[0];
                requestBody.expDate.endDate = requestBody.expDate.endDate.split('T')[0];

                let apiRequest3 = apiUtility.apiInputRequest;
                apiRequest3.endPoint = "audit-report/user-expiry-report";
                apiRequest3.data = requestBody;
                const response = await apiUtility.updateAsyncAPIDataPUT(apiRequest3);
                setExpCrsData(response.data);

            } catch (error) {
                setDataForErrorPopup("Error fetching data");
                setShowErrorPopup(true);
                setExpCrsData([]);
            } finally {
                setshowSpinner(false);
            }
        };
    const headerStyleElement = {
                position: 'sticky',
                top: 0,
                backgroundColor: '#ffffff', 
                borderBottom: '1px solid #016594', 
                zIndex: 1   ,
                
            }

    var adminHomeCrsCols = [
        {
            dataField: 'user_id',
            sort: true,
            text: 'User ID',
            headerStyle: headerStyleElement 
        },

        {
            dataField: 'first_name',
            sort: true,
            text: 'First Name',
            headerStyle: headerStyleElement
        },
        {
            dataField: 'last_name',
            sort: true,
            text: 'Last Name',
            headerStyle: headerStyleElement
        },
        {
            dataField: 'home_id',
            sort: true,
            text: 'Home ID',
            headerStyle: headerStyleElement
        },
        {
            dataField: 'role_name',
            sort: true,
            text: 'Role Name',
            headerStyle: headerStyleElement
        },
        {
            dataField: 'type',
            text: 'Course/Home Doc',
            headerStyle: headerStyleElement
        },
        {
            dataField: 'object_id',
            text: (props.category === "9") ?'Course ID' : (props.category === "10") ? 'Doc Code' : 'Course ID/Home Doc Code',
            headerStyle: headerStyleElement
        },
        {
            dataField: 'expiry_date',
            sort: true,
            text: 'Expiry Date',
            headerStyle: headerStyleElement
        },
        {
            dataField: 'enroll_date',
            sort: true,
            text: 'Last Enrollment Date',
            width:"100",
            headerStyle: headerStyleElement
        }
    ];

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };
    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    const exportInExcel = async () => {
        if (!expCrsData || expCrsData.length === 0) {
            setDataForErrorPopup("No data to export");
            setShowErrorPopup(true);
            return;
        }
        try {
            var rowsCount = 6;
            const title = [{A: 'Care Passport - Course Expiry Report for Users'}];
            let reportView = [{ A:'Name',B:'User ID',C:'Role',D:'Home ID',E:'Date'}];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null)?sessionStorage.getItem('userType').toUpperCase():"User",
                D: props.homeName+'('+props.homeId+')',
                E: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            let colName = (props.category == "9") ? 'Course ID' : (props.category == "10") ? 'Policy ID' : 'Course ID/Policy ID';
            let reportHeaders = {A:'User ID',B:'First Name',C:'Last Name',D:'Home ID',E:'Role Name',F:'Type', G:colName, H:'Expiry Date', I:'Last Enrollment Date'};
            reportView.push(reportHeaders);
           // expCrsData.forEach(element => {
            for (const element of expCrsData) {
                rowsCount += 1;
                var tempObj = {
                    A: element.user_id,
                    B: element.first_name,
                    C: element.last_name,
                    D: element.home_id,
                    E: element.role_name,
                    F: element.type,
                    G: element.object_id,
                    H: element.expiry_date,
                    I: element.enroll_date,
                };
                reportView.push(tempObj);
            };
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Expiry_Report");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "User ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: "A1:G1",
                tbodyRange: `A7:G${finalData.length}`,
                uHeadRange: `A2:E2`,
                uBodyRange: `A3:E3`,
                theadRange:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[0] + 1}:I${headerIndexes[0] + 1}`
                    : null,
                theadRange1:
                  headerIndexes?.length >= 2
                    ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                    : null,
                tFirstColumnRange:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                    : null,
                tLastColumnRange:
                  headerIndexes?.length >= 1
                    ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                    : null,
          
                tFirstColumnRange1:
                  headerIndexes?.length >= 1
                    ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                    : null,
                tLastColumnRange1:
                  headerIndexes?.length >= 1
                    ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                    : null,
              };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook)=>{
                workbook.sheets().forEach((sheet)=>{
                    sheet.column("A").width(15);
                    sheet.column("B").width(30);
                    sheet.column("C").width(50);
                    sheet.column("D").width(30);
                    sheet.column("E").width(30);
                    sheet.column("F").width(30);
                    sheet.column("G").width(30);
                    sheet.column("H").width(30);
                    sheet.column("I").width(30);
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily:"Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                          horizontalAlignment: "left",
                        });
                      }
                      sheet.range(dataInfo.theadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                      });
                      if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                          bold: true,
                        });
                      }
                     
                });
    
                return workbook.outputAsync().then((workbookBlob) => { 
                        const downloadAnchorNode = document.createElement("a");
                        let fileName = "Carepassport_ExpiryReport_"+new Date().toLocaleDateString()+".xlsx";
                        downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                        downloadAnchorNode.setAttribute("download", fileName);
                        downloadAnchorNode.click();
                        downloadAnchorNode.remove();
                });  
            });
        } catch (error) {
             setDataForErrorPopup("Something went wrong while processing excel!");
             setShowErrorPopup(true);
        }
    }

    const NoRowsOverlay = () => {
        return (
            <div className="text-center p-4">
            No records found for the selected date range.
            </div>
        );
        };

    const TABLE_CONTAINER_STYLE = {
        height: '700px',       
        overflowY: 'auto',     
        position: 'relative'   
    };

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            {showSpinner && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10, py: 2 }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </Box>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                <Tooltip title="Export to Excel" variant="solid">
                    <Button
                        size="sm"
                        variant="outlined"
                        color="primary"
                        //startDecorator={<RiFileExcel2Line/>}
                        onClick={exportInExcel}
                    >                    
                        <RiFileExcel2Line fontSize={"1.5pc"}/>
                    </Button>
                </Tooltip>
            </Box>
            <Sheet variant="outlined" sx={{borderRadius:"md"}} style={TABLE_CONTAINER_STYLE}>
                <BootstrapTable 
                        id='organizationStaffSpecificTable' 
                        keyField='id' 
                        data={expCrsData} 
                        columns={adminHomeCrsCols} 
                        noDataIndication={ NoRowsOverlay }
                        striped 
                        hover 
                    />
            </Sheet>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false)}}/> 
        </Box>
    )
}

export default CourseExpiryReport